<template>
  <div>
  <div class="market-container">
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
    <div class="row top-banner-wrapper">
      <h3 class="welcome-text">{{$t('marketPlace')}}</h3>
      <p class="welcome-sub-header pt-10">{{$t('PurchaseResourcesAndSubscriptions')}}</p>
      <p class="welcome-para">{{$t('SelfConformityDeclarationOffers')}}<br>{{$t('SelfConformityDeclarationOffersContinuation')}}</p>
    </div>

    <div class="row m-0 compliance-tracker-card common-styles">
      <p class="get-full-access">{{$t('innovativeServicesInclude')}}:
      </p>
      <div class="row mtb">
        <div class="col-xs-12 col-sm-12 col-md-6 img-padding">
          <div class="card">
            <img
            class="img-style default-style"
            src="/static/images/icons/EvidenceNewTheme.svg"
            alt="tracker block"
          />
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 card-padding">
          <div>
            <div class="d-flex pt-13">
              <img src="/static/images/icons/green_circle_check.svg" class="breadcrumb-img" />
              <p class="pl-17 sub-headers">{{$t('PortfolioManagement')}} <span class="fw-400">{{$t('PortfolioManagementSubHeader')}}:</span></p>
            </div>
            <p class="pl-40 desc-color">{{$t('portfolioDesc')}}</p>
          </div>
          <div class="pt-28">
            <div class="d-flex pt-13">
              <img src="/static/images/icons/green_circle_check.svg" class="breadcrumb-img" />
              <p class="pl-17 sub-headers">{{$t('RegulatoryIntelligence')}}</p>
            </div>
            <p class="pl-40 desc-color">{{$t('RegulatoryIntelligenceDesc')}}</p>
          </div>
        </div>
      </div>
      <div class="row mtb pb-10">
        <div class="col-xs-12 col-sm-12 col-md-6 pl-40 pt-15">
          <div>
            <div class="d-flex pt-13">
              <img src="/static/images/icons/green_circle_check.svg" class="breadcrumb-img" />
              <p class="pl-17 sub-headers">{{$t('ServiceProvidersAndResourcesMarketplace')}}</p>
            </div>
            <p class="pl-40 desc-color">{{$t('ServiceProvidersAndResourcesMarketplaceDesc')}}</p>
          </div>
          <div class="pt-28">
            <div class="d-flex pt-13">
              <img src="/static/images/icons/green_circle_check.svg" class="breadcrumb-img" />
              <p class="pl-17 sub-headers">{{$t('EvidenceRequirementsChecklist')}}</p>
            </div>
            <p class="pl-40 desc-color">{{$t('EvidenceRequirementsChecklistDesc')}}</p>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div class="card">
            <img
              class="img-style default-style"
              src="/static/images/icons/MarketplaceSecondImage.svg"
              alt="tracker block"
            />
          </div>
        </div>
      </div>
      <div class="row mlr-25">
        <table class="table table-responsive">
          <thead>
            <tr>
              <th v-for="(header,index) in finalTableHeaders" :key="index" class="ptb-38 cursor-text">
                <div class="column">
                  {{header.name}}
                </div>
                <div class="column-subname" :class="index === 1 ? 'pl-20' : ''">
                  {{header.subName}}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data,index) in finalTableData" :key="index" class="table-inner-border">
              <td style="width: 25%;" class="ptb-40 services-name">{{data.services}}</td>
              <td style="width: 20%;" class="ptb-40">
                <img :src="data.image" v-if="data.showIncludedImg" class="pr-8" />
                <img :src="data.not_included" v-else class="pr-8" />
                <span>{{data.freemium}}</span>
              </td>
              <td style="width: 20%;" class="ptb-40">
                <img :src="data.image" class="pr-8" />
                <span>{{data.proServices}}</span>
              </td>
              <td style="width: 20%;" class="ptb-40">
                <img :src="data.image" v-if="index === 0" class="pr-8" />
                <span>{{data.payPerUse}}</span>
              </td>
              <td style="width: 15%;" class="ptb-40">
                <img :src="data.image" v-if="index === 0" class="pr-8" />
                <span>{{data.subsrciption}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <hr class="line-break" />
      </div>
      <div class="pl-25">
        <div>
          <p class="pro-services-header">{{$t('PROServicesDesc')}}:</p>
        </div>
        <div class="border-color">
          <div class="freemium-text-wrapper">
            <p class="freemium">Freemium <span class="freemium-subheader">{{$t('PortfolioManagementSubHeader')}}</span></p>
            <p class="freemium-desc">{{$t('portfolioDesc')}}.</p>
          </div>
        </div>
        <div class="border-color freemium-text-wrapper pb-25 mt-24">
          <div class="d-flex">
            <p class="col-xs-6 pl-0 freemium" v-if="getSubscriptionDetails()">{{$t('PROServices')}}</p>
            <p class="col-xs-6 pl-0 freemium" v-else>{{ $t('additionalPurchase') }}</p>
            <p v-if="getSubscriptionDetails()" class="d-flex col-xs-6 justify-content-end pr-24 fs-16-fw-600">{{$t('basePrice')}}:<span class="fs-16-fw-400 pl-5"> {{ (new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(1399)) }} {{$t('perYear')}}</span></p>
          </div>
          <div class="pl-20 pt-22">
            <li><span class="fs-16-fw-600">{{$t('totalCertificates')}}:</span> <span class="fs-16-fw-400">{{certificate_count}}</span></li>
            <div class="d-flex pl-32 pt-24">
              <div class="checkbox-wrapper">
                <label class="custom-checkbox" :class="{'disable-content': getSubscriptionDetails()}">
                  <input type="checkbox" :class="`checkbox ${!(showHideAddToCartBtn()) ? 'cursor-not-allowed' : ''}`" v-model="selectCertificates" @change="updateServices()" :disabled="!(showHideAddToCartBtn())" />
                  <span :class="`select-check ${!(showHideAddToCartBtn()) ? 'cursor-not-allowed' : ''}`"></span>
                </label>
              </div>
              <p class="ml-10" v-if="getSubscriptionDetails()">{{$t('addAdditionalCertificate1')}}</p>
              <p class="ml-10" v-else>{{$t('addAdditionalCertificate2')}}</p>
            </div>
            <div class="d-flex pt-16-pl-70 align-items-center" :class="!selectCertificates && 'opacity'">
              <p class="m-0 div-center pr-34">{{$t('SelectNumberOf')}}<br/> {{$t('SelectNumberOfDesc')}}</p>
              <img @click="changeCertificatesCount('decrease')" :class="{'disable-content': getSubscriptionDetails() && certificate_count === 1}" src="/static/images/icons/marketplaceMinusIcon.svg" alt="minus" />
              <input type="text" :value="certificate_count" class="ml-16 dimensions cursor-disabled" />
              <img @click="changeCertificatesCount('increase')" class="ml-16" src="/static/images/icons/marketplacePlusIcon.svg" alt="plus" />
              <p class="pl-25 m-0 div-center">Total: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(certificate_total_amount) }}</p>
            </div>
          </div>
          <div>
            <hr class="hr-line" />
          </div>
          <div class="pl-20 pt-22">
            <li><span class="fs-16-fw-600">{{$t('totalUserIncluded')}}:</span> <span class="fs-16-fw-400">{{users_count}}</span></li>
            <div class="d-flex pl-32 pt-24">
              <div class="checkbox-wrapper">
                <label class="custom-checkbox" :class="{'disable-content': getSubscriptionDetails()}">
                  <input type="checkbox" :class="`checkbox ${!(showHideAddToCartBtn()) ? 'cursor-not-allowed' : ''}`" v-model="selectUsers" @change="updateServices()" :disabled="!(showHideAddToCartBtn())" />
                  <span :class="`select-check ${!(showHideAddToCartBtn()) ? 'cursor-not-allowed' : ''}`"></span>
                </label>
              </div>
              <p class="ml-10" v-if="getSubscriptionDetails()">{{$t('addAdditional1')}}</p>
              <p class="ml-10" v-else>{{$t('addAdditional2')}}</p>
            </div>
            <div class="d-flex pt-16-pl-70 align-items-center" :class="!selectUsers && 'opacity'">
              <p class="m-0 div-center" :class="$i18n.locale === 'English' ? 'pr-74' : 'pr-56'">{{$t('selectNumber')}}<br/> {{$t('selectNumberDesc')}}</p>
              <img @click="changeUsersCount('decrease')" :class="{'disable-content': getSubscriptionDetails() && users_count === 1}" src="/static/images/icons/marketplaceMinusIcon.svg" alt="minus" />
              <input type="text" :value="users_count" class="ml-16 dimensions cursor-disabled" />
              <img @click="changeUsersCount('increase')" class="ml-16" src="/static/images/icons/marketplacePlusIcon.svg" alt="plus" />
              <p class="pl-25 m-0 div-center">Total: {{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(users_total_amount) }}</p>
            </div>
          </div>
          <div>
            <hr class="hr-line opacity" />
          </div>

          <div class="d-flex">
            <div class="col-xs-6 pl-2">
              <p class="fs-16-fw-600">{{$t('ServiceInclude')}}:<br/> <span class="fs-16-fw-400"> {{$t('ServiceIncludeDesc')}}.</span></p>
            </div>
            <div class="col-xs-6 justify-content-end d-flex flex-direction-column align-items-end">
              <p class="mr-9" v-if="showHideAddToCartBtn()"><span class="fs-16-fw-600">Total:</span> <span class="fs-16-fw-400">{{ new Intl.NumberFormat(this.$i18n.locale === 'Portuguese' ? 'pt-BR' : 'en-US', { style: 'currency', currency: 'BRL' }).format(getTotalPrice()) }}</span><span v-if="getSubscriptionDetails()"> {{$t('perYear')}}</span></p>
              <button class="addToCart-btn mr-24" :class="$i18n.locale === 'English' ? 'plr-61' : 'plr-16'"  @click="renewSubscription" :disabled="disableAddToCart" v-if="((subscriptions.filter(obj => obj.subscriptionId === 2).length > 0 && (subscriptions.filter(obj => obj.subscriptionId === 2)[0].isActive === false)) &&
                (roleId === 1))">{{$t('renewSubscription')}}</button>
              <button class="addToCart-btn mr-9" :class="$i18n.locale === 'English' ? 'plr-61' : 'plr-16'"  @click="addToCart('2')" :disabled="disableAddToCart" v-if="showHideAddToCartBtn()"
              >{{$t('AddToCart')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MarketPlaceFooter />
    <cart-popup @closePopup="disableUsersAndCertificates"></cart-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import {
  addOnSubscription, getServicesInCart, removeFromCartApi,
} from '../../apis/marketPlace';
import { getSubscriptions } from '../../apis/registrations';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import MarketPlaceFooter from './MarketPlaceFooter.vue';
import CartPopup from './CartPopup.vue';
import { renewSubscription } from '../../apis/team';

export default {
  props: ['account_id', 'roleInfo'],
  data() {
    return {
      selectUsers: '',
      selectCertificates: '',
      users_count: 0,
      users_total_amount: 0,
      certificate_count: 0,
      certificate_total_amount: 0,
      loaderStatus: false,
      services: [],
      addedServices: [],
      allPlans: [],
      servicesList: [],
      selectedService: 'All Services',
      subscriptions: [],
      cart: [],
      redirectTo: '',
      roleId: '',
      finalTableHeaders: [],
      finalTableData: [],
      englishTableHeaders: [
        {
          name: 'Services',
          subName: '',
        },
        {
          name: 'Freemium',
          subName: '(Active)',
        },
        {
          name: 'PRO Services',
          subName: '',
        },
        {
          name: 'Pay Per Use',
          subName: '(Coming soon)',
        },
        {
          name: 'Subscription',
          subName: '(Coming soon)',
        },
      ],
      portugueseTableHeaders: [
        {
          name: 'Serviços',
          subName: '',
        },
        {
          name: 'Freemium',
          subName: '(Ativo)',
        },
        {
          name: 'Serviços PRO',
          subName: '',
        },
        {
          name: 'Pagamento por uso',
          subName: '(Em breve)',
        },
        {
          name: 'Assinatura',
          subName: '(Em breve)',
        },
      ],
      englishTableData: [
        {
          services: 'Portfolio Management',
          freemium: 'Included',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Included',
          payPerUse: 'Included',
          subsrciption: 'Included',
          showIncludedImg: true,
        },
        {
          services: 'Regulatory Guidance',
          freemium: 'Not Included',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Included',
          payPerUse: 'Pack of 5 Certifications',
          subsrciption: 'Coming Soon',
          showIncludedImg: false,
        },
        {
          services: 'Service Providers Catalog',
          freemium: 'Not Included',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Included',
          payPerUse: 'Pack of 5 Certifications',
          subsrciption: 'Coming Soon',
          showIncludedImg: false,
        },
        {
          services: 'Evidence Requirements Checklist',
          freemium: 'Not Included',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Included',
          payPerUse: 'Pack of 5 Certifications',
          subsrciption: 'Coming Soon',
          showIncludedImg: false,
        },
      ],
      portugueseTableData: [
        {
          services: 'Gerenciamento de portfólio',
          freemium: 'Incluso',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Incluso',
          payPerUse: 'Incluso',
          subsrciption: 'Incluso',
          showIncludedImg: true,
        },
        {
          services: 'Orientações regulatórias',
          freemium: 'Não Incluso',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Incluso',
          payPerUse: 'Pacote de 5 certificações',
          subsrciption: 'Em breve',
          showIncludedImg: false,
        },
        {
          services: 'Catálogo de provedores de serviço',
          freemium: 'Não Incluso',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Incluso',
          payPerUse: 'Pacote de 5 certificações',
          subsrciption: 'Em breve',
          showIncludedImg: false,
        },
        {
          services: 'Lista de requisitos de evidências',
          freemium: 'Não Incluso',
          image: '/static/images/icons/marketplaceTableGreenTick.svg',
          not_included: '/static/images/icons/not_included.svg',
          proServices: 'Incluso',
          payPerUse: 'Pacote de 5 certificações',
          subsrciption: 'Em breve',
          showIncludedImg: false,
        },
      ]
    };
  },
  components: { Loader, MarketPlaceFooter, CartPopup },
  methods: {
    updateServices() {
      if (!this.selectCertificates) {
        this.certificate_total_amount = 0;
        this.certificate_count = 0;
      }
      if (!this.selectUsers) {
        this.users_total_amount = 0;
        this.users_count = 0;
      }
    },
    getTotalPrice() {
      const total = this.users_total_amount + this.certificate_total_amount;
      return this.subscriptions.filter((obj) => obj.subscriptionId === 2).length === 0 ? (total + 1399).toFixed(2) : total.toFixed(2);
    },
    showHideAddToCartBtn() {
      return ((Object.keys(this.cart).length === 0) && (this.roleId === 1));
    },
    disableUsersAndCertificates() {
      this.selectUsers = '';
      this.selectCertificates = '';
    },
    getSubscriptionDetails() {
      return this.subscriptions.filter((obj) => obj.subscriptionId === 2).length === 0;
    },
    changeUsersCount(val) {
      if (val === 'increase') {
        this.users_count += 1;
        this.users_total_amount = this.users_count * 299;
      }
      if (val === 'decrease') {
        if (this.users_count > 0) {
          this.users_count -= 1;
          this.users_total_amount -= 299;
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Os usuários não podem ser diminuídos ainda mais' : 'Users cannot be decreased further',
            group: 'custom-notification',
          });
        }
      }
    },
    changeCertificatesCount(val) {
      if (val === 'increase') {
        this.certificate_count += 1;
        this.certificate_total_amount = this.certificate_count * 599;
      }
      if (val === 'decrease') {
        if (this.certificate_count > 0) {
          this.certificate_count -= 1;
          this.certificate_total_amount -= 599;
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Os certificados não podem ser diminuídos ainda mais' : 'Certificates cannot be decreased further',
            group: 'custom-notification',
          });
        }
      }
    },
    async getAllSubscriptions() {
      this.subscriptions = await getSubscriptions(true);
      if (this.getSubscriptionDetails()) {
        this.selectUsers = true;
        this.selectCertificates = true;
        this.users_count = 1;
        this.users_total_amount = 299;
        this.certificate_count = 1;
        this.certificate_total_amount = 599;
      }
    },
    async getCart() {
      this.cart = await getServicesInCart();
    },
    async removeFromCart(id) {
      await removeFromCartApi(id);
      this.cart = await getServicesInCart();
      EventBus.$emit('updateCart');
    },
    learnMore(id) {
      if (id === 1) {
        this.$router.push({ path: '/layout/market-place/product-compliance' });
      } else if (id === 4) {
        this.$router.push({ path: '/layout/market-place/resources' });
      }
      EventBus.$emit('activeMenuTitle', this.$route.name);
      // this.$router.push({ path: `/layout/market-place/service/${id}` });
      // EventBus.$emit('activeMenuTitle', this.$route.name);
    },
    async addToCart(id) {
      this.loaderStatus = true;
      const data = {
        subscriptionId: id,
        certificates_count: this.certificate_count === 0 ? null : this.certificate_count,
        certificates_purchase_amount: this.certificate_total_amount === 0 ? null : this.certificate_total_amount,
        users_count: this.users_count === 0 ? null : this.users_count,
        users_purchase_amount: this.users_total_amount === 0 ? null : this.users_total_amount,
      };
      const response = await addOnSubscription(data);
      if (response.status === 201) {
        this.loaderStatus = false;
        EventBus.$emit('updateCart');
        this.cart = await getServicesInCart();
        $('#cartPopup').modal({
          backdrop: 'static',
          keyboard: false,
        });
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    async renewSubscription() {
      this.loaderStatus = true;
      const response = await renewSubscription();
      if (response.status_code === 200) {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: response.message,
          group: 'custom-notification',
        });
        if (response.products_available === true) {
          this.subscriptions = await getSubscriptions(true);
        } else {
          this.loaderStatus = true;
          // const data = { subscriptionId: '2' };
          const data = {
            subscriptionId: '2',
            certificates_count: this.certificate_count,
            certificates_purchase_amount: this.certificate_total_amount,
            users_count: this.users_count,
            users_purchase_amount: this.users_total_amount,
          };
          const res = await addOnSubscription(data);
          if (res.status === 201) {
            this.loaderStatus = false;
            EventBus.$emit('updateCart');
            this.cart = await getServicesInCart();
            this.$router.push('/layout/viewCart');
          }
        }
        EventBus.$emit('updateHeaderMenu');
      } else {
        this.loaderStatus = false;
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'A renovação da assinatura falhou!' : 'Subscription renewal failed!',
          group: 'custom-notification',
        });
      }
    },
  },
  created() {
    const currentLanguage = localStorage.getItem('language');
    if (currentLanguage === 'Portuguese') {
      this.finalTableHeaders = this.portugueseTableHeaders;
      this.finalTableData = this.portugueseTableData;
    } else {
      this.finalTableHeaders = this.englishTableHeaders;
      this.finalTableData = this.englishTableData;
    }
    this.roleId = JSON.parse(localStorage.getItem('userData')).role_id;
    this.servicesList = ['All Services', 'Active Services', 'RAMS Services', 'Partner Services'];
    this.getAllSubscriptions();
    this.getCart();
    if (this.$route.query) {
      this.redirectTo = this.$route.query.from;
    }
    // EventBus.$on('updateRoute', () => {
    //   if (this.redirectTo === 'manageCompliance') {
    //     this.$router.push({ path: '/layout/manage-compliance' });
    //   } else if (this.redirectTo === 'complianceTracker') {
    //     this.$router.push({ path: '/layout/registration' });
    //   } else {
    //     this.$router.push({ path: '/layout/market-place' });
    //   }
    //   this.$router.go();
    // });
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
      if (language === 'Portuguese') {
        this.finalTableHeaders = this.portugueseTableHeaders;
        this.finalTableData = this.portugueseTableData;
      } else {
        this.finalTableHeaders = this.englishTableHeaders;
        this.finalTableData = this.englishTableData;
      }
    });
  },
  beforeDestroy() {
    // EventBus.$off('redirectTo');
  },
  filters: {
    UTCDate(date, format) {
      return date ? moment.utc(date).format(format) : '';
    },
  },
  computed: {
    disableAddToCart() {
      if (!this.users_count && !this.certificate_count) return true;
      if ((this.selectUsers && !this.users_count) || (this.selectCertificates && !this.certificate_count)) return true;
      return false;
    },
    filterServices() {
      let filteredServices = '';
      if (this.$i18n.locale === 'English') {
        filteredServices = [
          {
            id: 1,
            name: 'Compliance Tracker',
            description: 'A self serve solution to register, search records and manage compliance aspects of your products. So that you can focus on business growth.',
          },
          {
            id: 4,
            name: 'Resources',
            description: 'Keeping track of rapidly evolving Brazilian standards and regulations. Search for qualified Labs and Testing facilities.',
          },
        ];
      } else {
        filteredServices = [
          {
            id: 1,
            name: 'Rastreador de Conformidade',
            description: 'Uma solução de autoatendimento para registrar, pesquisar registros e gerenciar aspectos de conformidade de seus produtos. Para que você possa se concentrar no crescimento do negócio.',
          },
          {
            id: 4,
            name: 'Recursos',
            description: 'Acompanhando as normas e regulamentações brasileiras em rápida evolução. Procure por laboratórios qualificados e instalações de teste.',
          },
        ];
      }
      return filteredServices;
    },
    learnMoreTranslation() {
      let learnMoreLang = '';
      if (this.$i18n.locale === 'English') {
        learnMoreLang = 'Learn More';
      } else {
        learnMoreLang = 'Saber mais';
      }
      return learnMoreLang;
    },
    NEWTranslation() {
      let newPlaceHolder = '';
      if (this.$i18n.locale === 'English') {
        newPlaceHolder = 'NEW';
      } else {
        newPlaceHolder = 'NOVA';
      }
      return newPlaceHolder;
    },
  },
};
</script>
<style scoped>
.cursor-text {
  cursor: text !important
}
.btn-dimension {
  width: 34px;
  height: 34px;
}
.desc-color {
  color: #3E3E3E;
}
.pr-8 {
  padding-right: 8px;
  margin-top: -2px;
}
.freemium {
  font-size: 18px;
  font-weight: 600;
  color: #3E3E3E;
}
.fs-16-fw-600 {
  font-size: 16px;
  font-weight: 600;
  color: #3E3E3E;
}
.fs-16-fw-400 {
  font-size: 16px;
  font-weight: 400;
  color: #3E3E3E;
}
.freemium-subheader {
  font-size: 18px;
  font-weight: 400;
  color: #3E3E3E;
}
.freemium-desc {
  font-size: 16px;
  color: #3E3E3E;
}
.pro-services-header {
  font-size: 20px;
  font-weight: 600;
  color: #3E3E3E;
  margin-bottom: 24px;
}
.services-name {
  color: #3E3E3E;
  font-weight: 600;
  font-size: 18px;
}
.column-subname {
  color: #3E3E3E;
}
.pt-15 {
  padding-top: 15px;
}
.sub-headers {
  color: #3E3E3E;
  font-size: 20px;
  font-weight: 600;
  padding-left: 16px;
}
.pl-40 {
  padding-left: 40px;
}
.fw-400 {
  font-weight: 400 !important;
}
.cursor-disabled {
  cursor: not-allowed;
  pointer-events: none;
}
.opacity {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.mt-24 {
  margin-top: 24px;
  margin-bottom: 35px;
}
.pt-22 {
  padding-top: 22px;
}
.line-break {
  margin: 40px 0px 40px 27px;
  border-top: 1px solid #D3D3D3;
}
.hr-line {
  border-top: 0.7px solid #BDBDBD;
  margin: 37px 22px 24px 2px;
}
.freemium-text-wrapper {
  padding: 16px 0 10px 24px;
}
.pb-25 {
  padding-bottom: 25px;
}
.border-color {
  border: 1px solid #B3B3B3;
}
.table>thead>tr>th {
  vertical-align: top;
}
.table-inner-border {
  border-bottom: 0.7px solid #BDBDBD;
}
.table-inner-border:last-child {
  border-bottom: none;
}
.column {
  display: flex;
  flex-direction: column;
  color: #3E3E3E;
  font-size: 20px;
}
.table {
  margin-bottom: 0px;
}
.table thead {
  background-color: #ffffff;
}
.mlr-25 {
  /* margin: 0px 25px; */
  margin: 0 0 0 25px;
  border: 1px solid #B3B3B3;
}
.ptb-40 {
  padding: 41px 7px 41px 24px !important;
  color: #3E3E3E;
}
.ptb-38 {
  padding: 24px 7px 23px 24px !important;
}
.resources-card {
  display: flex;
  justify-content: flex-end;
  padding-right: 32px;
}
.welcome-text {
  color: #ffffff;
  font-weight: 300;
  font-size: 42px;
  line-height: 57px;
}
.pl-6 {
  padding-left: 6px;
}
.mtb {
  margin-top: 20px;
  margin-bottom: 37px;
}
.welcome-sub-header {
  font-weight: 400;
font-size: 16px;
line-height: 22px;
color: #FFFFFF;
}
.welcome-para {
font-size: 16px;
line-height: 22px;
font-weight: 300;
color: #FFFFFF;
}
.pl-2 {
  padding-left: 2px;
}
.addToCart-btn {
  background: #01518A;
  border-radius: 3px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  border: none;
  height: 44px;
  padding:6px 16px;
  display: flex;
  justify-content: flex-end;
}
.addToCart-btn:disabled {
  cursor: not-allowed;
}
.plr-61 {
  padding: 9.5px 61px;
}
.plr-16 {
  padding: 9.5px 16px;
}
.services-heading {
  color: #3E3E3E;
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 10px;
}
.pl-34 {
  padding-left: 34px;
}
.mt-8 {
  margin-top: 8px;
}
.mt-38 {
  margin-top: 38px;
  margin-left: 46px;
}
.pt-28 {
  padding-top: 28px;
}
.mr-9 {
  margin-right: 9px;
}
.card-padding {
  padding-top: 10px;
  padding-left: 32px;
}
.pt-31 {
  padding-top: 5px;
}
.view-details {
  border-radius: 3px;
  border: 1px solid #000001;
  width: 160px;
  height: 44px;
  background: #ffffff;
  color: #404040;
  font-size: 18px;
  font-weight: 600;
  margin-top: 42px;
}
.breadcrumb-img {
  width: 23px;
  height: 23px;
  margin-top: 1px;
}
.pl-6 {
  padding-left: 6px;
}
.img-padding {
  padding-left: 40px;
  padding-top: 11px;
}
.compliance-tracker-text {
  padding-left: 9px;
  padding-right: 70px;
  padding-top: 23px;
  line-height: 22px !important;
}
.card-heading {
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
  color: #3E3E3E;
  padding-top: 18px;
}
.card-heading-text {
  font-size: 16px;
  color: #3E3E3E;
  line-height: 26px;
}
.add-to-cart-btn-text{
  background-color: #01518A;
  border: 1px solid #01518A;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 25px;
  cursor: pointer;
  padding: 9px 50px 9px 50px;
}
.marketplace-cards {
  border: 1px solid #B3B3B3;
  height: 153px;
}
.card-1 {
  margin-left: 10px;
  margin-right: 11px;
  margin-bottom: 24px;
}
.card-2 {
  margin-left: 12px;
  margin-right: 9px;
  margin-bottom: 24px;
}
.img-style {
  width: 100%;
  /* height: 253px; */
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}
.mt-30 {
  margin-top: 30px;
}
.add-to-cart-btn {
  position: absolute;
  bottom: 27px;
  right: 7px;
  display: flex;
  justify-content: flex-end;
}
.common-styles {
  border: 1px solid #B3B3B3;
  background: #ffffff;
  margin-left: 24px;
  margin-right: 24px;
  padding-left: 15px;
  padding-right: 40px;
}
.compliance-tracker-card {
  position: relative;
  min-height: 416px;
  margin-top: -89px;
  margin-bottom: 24px;
  max-width: 1300px;
}
.marketplace-resources-card {
  min-height: 446px;
  margin-top: 24px;
  margin-bottom: 23px;
}
.full-access-container {
  margin-top: -116px;
  width: -webkit-fill-available;
  width: -moz-available;
  width: -ms-available;
}
.get-full-access {
  font-size: 24px;
  font-weight: 300;
  line-height: 33px;
  color: #3E3E3E;
  padding-left: 9px;
  padding-top: 18px;
}
.width-height-32 {
  width: 32px !important;
  height: 32px !important;
}
.align-right{
  display: flex;
  align-items: center;
  float: right;
  margin-right: 16px;
}
.align-right>p {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.multiselect-dropdown {
  flex: 1;
}
.service-card {
  position: relative
}
.top-banner-wrapper {
  background: url('/static/images/logos/marketplaceNewPageBanner.svg') no-repeat;
  background-size: cover;
  height: 304px;
  padding-left: 37px;
}
.pb-20 {
  padding-bottom: 20px;
}
.heading {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #ba212f;
  float: left;
}
.p-0 {
  padding: 0px;
}
.pr-30 {
  padding-right: 30px;
}

.mb-16 {
  margin-bottom: 16px;
}
.market-card {
  text-align: center;
  background: #ffffff;
  border: 0.5px solid #C1C3C6;
  border-radius: 4px;
  margin-bottom: 30px;
  max-width: 296px;
}

.inner-card {
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 11px;
  color: #174c76;
  min-height: 309px;
  padding: 32px 24px 14px 24px;
}
.market-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.card-title {
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #01518A;
  display: flex;
  text-align: center;
}
.details {
  min-height: 160px;
  position: relative;
  padding: 10px;
}
.mb-50 {
  margin-bottom: 50px;
}
.details-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #3E3E3E;
  height: 136px;
  overflow-y: hidden;
}
.details-text:hover {
  overflow-y: auto;
  scrollbar-width: thin;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;
;
}
.pl-0 {
  padding-left: 0px;
}

.learn-more {
  position:absolute;
  bottom: 40px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #01518A;
  cursor:pointer;
  margin-bottom: 10px;
}

.separator{
  margin: 0 24px 16px
}

.free-trial-text {
  left: 24px !important;
  top: 27px !important;
}

.status {
  display: flex;
  justify-content: center;
  align-items: center;
}
.status>img {
  margin: 0 6px
}
.status>span{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.check-icon {
  width: 18px;
  background: green;
  padding: 4px;
  border-radius: 50px;
  height: 18px;
}
.rectangle-icon {
  position: absolute;
  z-index: 1;
  top: 0px;
  left: 0px;
  transform: rotate(269.7deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(360deg);
  -ms-transform: rotate(269.7deg);
  -o-transform: rotate(269.7deg);
  width: 105px;
  height: 90px
}
.free-text {
  position: absolute;
  z-index: 1;
  left: 8px;
  top: 23px;
  -webkit-transform: rotate(312deg);
  -moz-transform: rotate(312deg);
  -ms-transform: rotate(312deg);
  -o-transform: rotate(312deg);
  transform: rotate(312deg);
  font-weight: bold;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  padding: 0;
  text-align: center;
  transform: rotate(-40deg);
}
.free-text-pc {
  left: 24px;
  top: 24px;
}
.free-text-gg {
  top: 28px !important;
}
.offer-text {
  position: absolute;
  z-index: 1;
  top: 47px;
  left: -8px;
  -webkit-transform: rotate(312deg);
  -moz-transform: rotate(312deg);
  -ms-transform: rotate(312deg);
  -o-transform: rotate(312deg);
  transform: rotate(312deg);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;
  padding: 0;
}
.offer-text-gg {
  top: 48px !important;
  left: 29px !important;
}
.title {
  font-size: 18px;
  margin: 5px;
  font-weight: 100;
  color: #FFFFFF;
}
.traingle-alert {
  width: 17px;
  margin-right: 10px;
  vertical-align: top;
}

.market-img{
  height: 30px;
  width: 30px;
}
@media only screen and (max-width: 414px) {
  .details {
    margin-bottom: 20px;
  }
  .pr-30 {
    padding-right: 0px;
  }

  .align-right {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media screen and (min-width: 2304px) {
  .width-23 {
    width: 70px;
  }
}
@media (min-width: 1400px) and (max-width: 1900px) {
  .market-img {
    width: 70px;
  }
  .width-23 {
    width: 60px;
  }
}
@media screen and (max-width: 767px) {
  .check-icon{
    right:45px;
  }
  .expiry-body {
    width: 70%;
  }

  .align-right {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (min-width: 993px) and (max-width: 1399px) {
  .rectangle-icon {
    width: 106px;
    left: 0px;
  }
  .free-text {
    left: 5px;
    top: 20px;
  }
  .offer-text {
    top: 45px;
    left: -12px;
  }
  .free-text-pc{
    left: 26px;
    top: 24px;
  }
  .offer-text-gg {
    top: 43px !important;
    left: 26px !important;
  }
  .free-text-gg {
    left: 10px !important;
    top: 26px !important;
  }
  .free-trial-text {
    left: 24px !important;
    top: 27px !important;
  }
  .expiry-body {
    width: 70%;
    height: 25px;
  }
  .title {
    font-size: 13px;
    margin: 5px;
  }
  .traingle-alert {
    width: 13px;
  }
  .extra-width {
    width: 82px;
  }
  .width-23 {
    width: 70px;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .width-23 {
    width: 70px;
  }
  .expiry-body {
    width: 75%;
    height: 35px;
  }
  .title {
    font-size: 20px;
    margin: 6px;
  }
  .traingle-alert {
    width: 20px;
  }
}
@media screen and (max-width: 576px) {
 .check-icon{
    right: 45px;
  }
.title {
    font-size: 15px;
    margin: 6px;
  }
  .traingle-alert {
    width: 15px;
  }
}
.free-trial-text{
  left: 24px;
  top: 24px;
}
.view-all {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #00518A;
    padding: 10px 40px 0 0;
}
@media (min-width: 1301px) and (max-width: 1399px){
  .img-style {
    width: 100% !important;
  }
  /* .common-styles {
    margin-left: auto;
    margin-right: auto;
  } */
}
@media (min-width: 1000px) and (max-width: 1024px){
  .plr-61 {
    padding: 9.5px 24px;
  }
}
@media (min-width: 1578px) {
  .img-style {
    width: 100% !important;
    /* height: auto; */
  }
  .common-styles {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
